<template>
  <td class="align-middle text-center" :class="getStatusColorClass(status)">
    {{ splitCamelCase(status) }}
  </td>
</template>

<script>
import { useReport } from '@/use/report'
import { useHelper } from '@/use/helper'

export default {
  props: {
    status: {
      default: ''
    }
  },
  setup() {
    const { getStatusColorClass } = useReport()
    const { splitCamelCase } = useHelper()
    return {
      getStatusColorClass,
      splitCamelCase
    }
  }
}
</script>
